import { useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { Sidebar } from "./Sidebar";
import { DashboardHeader } from "./Navbar";
import { getActiveRoute } from "@/shared/utils/get-active-route";

export function DashboardLayout() {
  const [sidebarOpen, setSidebarOpen] = useState(true);

  const location = useLocation();
  const currentPage = getActiveRoute(location.pathname);

  return (
    <div className="flex h-screen bg-[var(--surface-subtle-hex)]">
      <Sidebar
        isOpen={sidebarOpen}
        onToggle={() => setSidebarOpen(!sidebarOpen)}
        currentPage={currentPage}
      />

      <div className="flex-1 flex flex-col overflow-hidden">
        <DashboardHeader
          currentPage={currentPage}
          onMenuClick={() => setSidebarOpen(!sidebarOpen)}
        />

        <main
          className={`flex-1 bg-white ${"overflow-y-auto px-[1.88rem] py-[1.25rem]"}`}
        >
          <Outlet />
        </main>
      </div>
    </div>
  );
}
